import React from "react";
import "./index.css";

import SectionHeader from "../SectionHeader";

const SupportedGames = () => {
  return (
    <div className="supported-games">
      <SectionHeader>Supported Games</SectionHeader>
      <div className="supported-games-images">
        <div className="supported-game-image">
          <img src="/images/squad-square.png" alt="Squad" />
        </div>
        <div className="supported-game-image">
          <img src="/images/enlisted_square.jpg" alt="Enlisted" />
        </div>
        <div className="supported-game-image">
          <img src="/images/hell-let-loose_square.jpg" alt="Hell Let Loose" />
        </div>
        <div className="supported-game-image">
          <img src="/images/HD2W-square.jpg" alt="HD2" />
        </div>
        <div className="supported-game-image">... and more!</div>
      </div>
    </div>
  );
};

export default SupportedGames;
